import * as React from 'react';
import { Row } from 'react-bootstrap';

import { useToggle } from 'af-utils/react.util';

import LockedValue from 'af-components/LockedValue';

import CompanyPolicyPreviewModal from './Preview/CompanyPolicyPreviewModal';
import styles from './styles.module.scss';
import SettingPreview from '../../Shared/SettingPreview';

interface Props {
	companyPolicyAttachmentName: Nullable<string>;
	toggleEdit: () => void;
}

const CompanyPolicyPreview: React.FC<Props> = (props) => {
	const { toggleEdit, companyPolicyAttachmentName } = props;

	const {
		value: showCompanyPolicy,
		setToTrue: openCompanyPolicyModal,
		setToFalse: closeCompanyPolicyModal,
	} = useToggle(false);

	return (
		<SettingPreview toggleEdit={toggleEdit}>
			<div className="company-settings__info-segment">
				<Row className="row--padded">
					<div className={styles.filePreview}>
						<div>
							<LockedValue
								label="Company policy"
								value={companyPolicyAttachmentName}
							/>
						</div>
						{!!companyPolicyAttachmentName && <div className={`icon-zoom_in ${styles.preview}`} onClick={openCompanyPolicyModal} />}
					</div>
				</Row>
			</div>
			<CompanyPolicyPreviewModal
				closeModal={closeCompanyPolicyModal}
				showModal={showCompanyPolicy}
			/>
		</SettingPreview>
	);
};

export default React.memo(CompanyPolicyPreview);
